import { postScheduleInternalMutation } from "@aura-frontend/omnibus-az-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { SCHEDULES_QUERY_KEY } from "../Complexes/SingleField/FieldSchedule/FieldSchedule.queries";

export const useCreateEvent = ({
  onSuccess,
}: {
  onSuccess?: (machineUuid: string) => void;
} = {}) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    ...postScheduleInternalMutation(),
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({
        queryKey: [SCHEDULES_QUERY_KEY],
        exact: false,
        refetchType: "all",
      });
      onSuccess?.(data.machine_uuid);
    },
  });

  return { createEvent: mutate, isCreatingEvent: isPending };
};
